<template>
  <v-dialog v-model="dialog">
    <v-card class="mapCard" style="height: 80vh;">
      <v-btn
        class="mx-2 cancelBtnMap"
        fab
        dark
        small
        color="white"
        @click="closeDialog()"
      >
        <v-icon color="black" size="23">fas fa-xmark</v-icon>
      </v-btn>
      <div class="mapContent" style="height: 80vh;" v-if="listData.length !== 0">
        <gmap-map
          :center="gmapCenter"
          :zoom="8"
          :options="{
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
          }"
          style="width:100%;  height: 100%;"
          ref="mapRef"
        >
        <gmap-marker
          v-for="(position, index) in listData"
          :key="index"
          :position="getLatLng(position)"
          :clickable="true"
          :draggable="false"
          :icon="{ url: getIcon(position)}"
          @click="getLocation(position, index)"
        >
        <gmap-info-window
          class="pa-3"
          v-if="showByIndex === index"
          :opened="showByIndex == index"
          :position="infoPosition"
          @closeclick="closeWindow()"
        >
          <CardWindowMap v-if="courseData" :courseData="courseData" :key="index"/>
          <div class="pa-8" v-else-if="isLoading">
            <SpinnerMap />
          </div>
        </gmap-info-window>
        </gmap-marker>
        </gmap-map>
      </div>
      <div class="d-flex flex-column align-center justify-center" style="height: 100%" v-else>
        <SpinnerMap />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import GolfCourseService from "@/services/GolfCourseService";
import CardWindowMap from "@/components/Card/CardWindowMap";
import SpinnerMap from "@/components/SpinnerMap";
export default {
  name: "DialogGoogleMap",
  components: {CardWindowMap, SpinnerMap},
  data() {
    return {
      dialog: false,
      listData: [],
      gmapCenter: {},
      showByIndex: null,
      infoPosition: null,
      courseData: null,
      isLoading: false,
      slugCourse: null,
      googleUrl: '',
    };
  },
  methods: {
    splitDataMarker(str) {
      return str.split(",")
    },
    async open(countryCode, slugCourse, googleUrl) {
      this.slugCourse = slugCourse
      this.googleUrl = googleUrl
      this.dialog = true;
      this.listData = []
      const listLocation = await GolfCourseService.getListGolfCourseLocation(countryCode.id)
      if (listLocation.error) {
        this.$toast.alert(`${listLocation.error.message}`);
        this.isLoading = false
        this.dialog = false
      } else {
        listLocation.map(golfCourse => {
          if(golfCourse) {
            const position = this.splitDataMarker(golfCourse)
            if(!isNaN(position[1]) && !isNaN(position[2])) {
              let strGolfcourse = ''
              //lấy 2 điểm xong gọi API, sẽ trả về các golf course khác có trong khung map đó
              // if(googleUrl) {
              //   this.gmapCenter= this.getLatLng(golfCourse)
              // }
              if(slugCourse && slugCourse == position[0]) {
                this.gmapCenter= this.getLatLng(golfCourse)
                strGolfcourse = golfCourse + ',' + this.imgUrl('gmap-marker.png')
              } else {
                strGolfcourse = golfCourse + ',' + this.imgUrl('gmap-marker-default.png')
              }
                this.listData.push(strGolfcourse)
            } else return true;
          }
        })
        if(!slugCourse) {
          const focusFirstPosition = this.listData[0]
          this.gmapCenter= this.getLatLng(focusFirstPosition)
        }
      }
    },
    async getLocation(position, index) {
      this.courseData = null
      this.isLoading = true
      this.infoPosition = this.getLatLng(position)
      this.showByIndex = index;
      const slugCourse = this.splitDataMarker(position)[0]
      const data = await GolfCourseService.getCourseById(slugCourse)
      if(data) {
        this.courseData = data
      } else {
        this.courseData = null
      }
    },
    getLatLng(positionString) {
      const position = this.splitDataMarker(positionString)
      return {lat: parseFloat(position[1]), lng: parseFloat(position[2])}
    },
    getIcon(positionString) {
      const position = this.splitDataMarker(positionString)
      return position[3]
    },
    closeWindow() {
      this.showByIndex = false
      this.courseData = null
      this.isLoading = false
    },
    closeDialog() {
      this.dialog = false
      this.showByIndex = false
    }
  }
};
</script>
